import { Button } from '@mui/material';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { EXCEL_COLUMNS, FILE_NAME, FONT_COLOR_RED } from '../constants/Constants';

export interface Keyword {
    id: number;
    keyword: string;
    count: number;
    clause: string;
    isEditing?: boolean;
    isExcluded?: boolean;
}

export interface KeywordCountDownloadProps {
    keywords: Keyword[];
    excludedKeywords: Keyword[];
    mergeStatus: string;
}

const createExcelWorksheet = (keywords: Keyword[], excludedKeywords: Keyword[]) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('CountResult');

    worksheet.columns = EXCEL_COLUMNS;

    const maxLength = Math.max(keywords.length, excludedKeywords.length);
    for (let i = 0; i < maxLength; i++) {
        const searchKeyword = keywords[i] ? keywords[i].keyword : '';
        const searchCount = searchKeyword ? keywords[i].count : '';
        const excludeKeyword = excludedKeywords[i] ? excludedKeywords[i].keyword : '';
        const excludeCount = excludeKeyword ? excludedKeywords[i].count : '';

        const row = worksheet.addRow({
            searchKeyword: searchKeyword,
            searchCount: searchCount,
            excludeKeyword: excludeKeyword,
            excludeCount: excludeCount
        });

        if (typeof searchCount === 'number' && searchCount >= 1) {
            row.getCell(2).font = { color: { argb: FONT_COLOR_RED }, bold: true };
        }
        if (typeof excludeCount === 'number' && excludeCount >= 1) {
            row.getCell(4).font = { color: { argb: FONT_COLOR_RED }, bold: true };
        }
    }

    return workbook;
};

const downloadExcelFile = async (workbook: ExcelJS.Workbook) => {
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, FILE_NAME);
};

const KeywordCountDownload: React.FC<KeywordCountDownloadProps> = ({ keywords, excludedKeywords, mergeStatus }) => {

    const downloadExcel = async () => {
        const workbook = createExcelWorksheet(keywords, excludedKeywords);
        await downloadExcelFile(workbook);
    };

    return (
        <Button
            className='download-button'
            onClick={downloadExcel}
            variant='contained'
            disabled={mergeStatus !== 'completed'}
        >
            Excelにエクスポート
        </Button>
    );
};

export default KeywordCountDownload;
